import Card, { CardTitle } from "./Card";
import React, { useState } from "react";
import { AUDIENCE_TYPES, AUDIENCE_TYPES_ARRAY } from "posts/constants";
import DonutGraph from "components/DonutGraph";
import CompareModal from "./CompareModal";
import { COLORS } from "utils/styles.js";
import { getAudienceEmoji } from "posts/constants";

export default function EducationCard(props) {
  const { activeAudience } = props;

  const renderData = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        // Note: Color is added for the onMouseOver() function in DonutGraph component
        return [
          { x: "Some HS (SH)", y: 2, color: "#B3E1E5", initials: "SH" },
          { x: "HS grad (HG)", y: 15, color: "#8CD3D9", initials: "HG" },
          { x: "Some college (SC)", y: 51, color: "#66C4CC", initials: "SC" },
          { x: "College grad (CG)", y: 20, color: "#40B5BF", initials: "CG" },
          { x: "Post-grad (PG)", y: 10, color: "#339199", initials: "PG" },
          { x: "Declined (N/A)", y: 2, color: "#266D73", initials: "N/A" },
        ];
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return [
          { x: "Some HS (SH)", y: 1, color: "#FFD8CC", initials: "SH" },
          { x: "HS grad (HG)", y: 20, color: "#FFB399", initials: "HG" },
          { x: "Some college (SC)", y: 48, color: "#FF8C66", initials: "SC" },
          { x: "College grad (CG)", y: 20, color: "#FF6633", initials: "CG" },
          { x: "Post-grad (PG)", y: 10, color: "#FF4000", initials: "PG" },
          { x: "Declined (N/A)", y: 1, color: "#CC3300", initials: "N/A" },
        ];
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return [
          { x: "Some HS (SH)", y: 1, color: "#FFE6FF", initials: "SH" },
          { x: "HS grad (HG)", y: 8, color: "#FFCCFF", initials: "HG" },
          { x: "Some college (SC)", y: 48, color: "#FFB3FF", initials: "SC" },
          { x: "College grad (CG)", y: 25, color: "#FF99FF", initials: "CG" },
          { x: "Post-grad (PG)", y: 17, color: "#E052E0", initials: "PG" },
          { x: "Declined (N/A)", y: 1, color: "#A329A3", initials: "N/A" },
        ];
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return [
          { x: "Some HS (SH)", y: 2, color: "#E0D3B8", initials: "SH" },
          { x: "HS grad (HG)", y: 11, color: "#D1BD94", initials: "HG" },
          { x: "Some college (SC)", y: 49, color: "#C2A770", initials: "SC" },
          { x: "College grad (CG)", y: 24, color: "#B3914D", initials: "CG" },
          { x: "Post-grad (PG)", y: 13, color: "#8F743D", initials: "PG" },
          { x: "Declined (N/A)", y: 1, color: "#6B572E", initials: "N/A" },
        ];
    }
  };

  const renderColorScale = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return COLORS.TOUGH_COOKIES_PALETTE;
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return COLORS.DONT_TREAD_ON_ME_PALETTE;
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return COLORS.PEOPLE_POWER_PALETTE;
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return COLORS.IF_YOU_SAY_SO_PALETTE;
    }
  };

  const data = renderData(activeAudience);
  const colors = renderColorScale(activeAudience);

  const [showCompare, setShowCompare] = useState(false);

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Education
      </CardTitle>

      <DonutGraph name="educationChart" colors={colors} data={data} extras="" />

      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>Compare Audiences – Education</CompareModal.Title>
        </CompareModal.Header>{" "}
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`education-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    <DonutGraph
                      colors={renderColorScale(type)}
                      data={renderData(type)}
                      extras=""
                    />
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}
